// extracted by mini-css-extract-plugin
export default {"wrapper":"jobs_wrapper__thaPs","page":"jobs_page__Ht-UF","jobs":"jobs_jobs__eSuW0","categories":"jobs_categories__qxMAV","category":"jobs_category__l5F8d"};